import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';

import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';

import { toggleSidebar } from '../../store/actions/layout';

const skater = new Icon({
   iconUrl: `/img/side.svg`,
   iconSize: [25, 25],
});
const pipe = () => (
   <span
      style={{
         width: '110px',
         height: '2px',
         background: 'orange',
         marginTop: '3px',
      }}
   ></span>
);

const AboutUs = () => {
   const dispatch = useDispatch();
   const location = useLocation();
   const { isSidebarOpened } = useSelector((state) => state.layout);

   useEffect(() => {
      if (!location.hash) {
         window.scrollTo(0, 0);
      }
   }, []);

   return (
      <main className='main' onClick={() => isSidebarOpened && dispatch(toggleSidebar())}>
         <div className='sidebar'>
            <a
               href='#about'
               className='sidebar__list'
               style={
                  location.hash === '#about'
                     ? { filter: 'drop-shadow(1px -2px 4px rgba(254,148,26,.3))' }
                     : {}
               }
            >
               <img src='/img/team.png' className='sidebar__svg' />
               <h1 className='sidebar__title'>درباره ما</h1>
               {location.hash === '#about' && pipe()}
            </a>

            <a
               href='#values'
               className='sidebar__list'
               style={
                  location.hash === '#values'
                     ? { filter: 'drop-shadow(1px -2px 4px rgba(254,148,26,.3))' }
                     : {}
               }
            >
               <img src='/img/diamond.png' className='sidebar__svg' />
               <h1 className='sidebar__title'>ارزش های بنیادی</h1>
               {location.hash === '#values' && pipe()}
            </a>

            <a
               href='#rights'
               className='sidebar__list'
               style={
                  location.hash === '#rights'
                     ? { filter: 'drop-shadow(1px -2px 4px rgba(254,148,26,.3))' }
                     : {}
               }
            >
               <img src='/img/humanity.png' className='sidebar__svg' />
               <h1 className='sidebar__title'>حقوق مشتریان</h1>
               {location.hash === '#rights' && pipe()}
            </a>

            <a
               href='#managers'
               className='sidebar__list'
               style={
                  location.hash === '#managers'
                     ? { filter: 'drop-shadow(1px -2px 4px rgba(254,148,26,.3))' }
                     : {}
               }
            >
               <img src='/img/owner.png' className='sidebar__svg' />
               <h1 className='sidebar__title'>مدیران سازمانی</h1>
               {location.hash === '#managers' && pipe()}
            </a>

            <a
               href='#contact'
               className='sidebar__list'
               style={
                  location.hash === '#contact'
                     ? { filter: 'drop-shadow(1px -2px 4px rgba(254,148,26,.3))' }
                     : {}
               }
            >
               <img src='/img/phone.svg' className='sidebar__svg' />
               <h1 className='sidebar__title'>ارتباط با ما</h1>
               {location.hash === '#contact' && pipe()}
            </a>
         </div>

         <section className='info'>
            <div id='about' className='info__about'>
               <div className='info__about-content'>
                  <img src='/img/team.png' alt='aboutUs' className='info__about-img' />
                  <h2 className='info__about-title'>درباره ما</h2>
               </div>
               <div className='info__about-container'>
                  <p className='info__about-text'>
                     اتوبوس یا گذربر خودروی حمل و نقل عمومی است که با توجه به موارد زمینه خدمت رسانی
                     به دو گروه: بیرون شهری و درون شهری تقسیم می‌گردند نخستین اتوبوس ایران به وسیله
                     بازرگان بلژیکی در استان گیلان شهر رشت مورد استفاده قرار گرفت، ولی با سپری شدن
                     زمان با در نظر گرفتن مقدار قیمت اتوبوس و هزینه کرایه اتوبوس، زیرساخت های حمل و
                     نقل و سوددهی از نظر اقتصادی مورد قبول واقع نشد و به همین دلیل اتوبوس ذکر شده به
                     یکی از تجار ایرانی با نام معین التجار واگذار شد. معین التجار نیز بعد از انقلاب
                     مشروطه اتوبوس را به شهر تهران آورد و با نرخ کرایه برای هر نفر سه شاهی آغاز به
                     کار کرد که با سپری شدن زمان نیاز به استفاده از این وسیله افزایش یافت. بعد از
                     چند سال تاریخچه اتوبوسرانی ایران با تعدادی با ورود اتوبوس توسط بازرگانان زیادی
                     به شهر ادامه یافت که موجب به توسعه در حمل و نقل مسافرین شد. گاها این اتوبوس ها
                     با در نظر گرفتن فاصله عبور شده از اروپا تا شهر مورد استفاده در ایران، از نظر
                     فاصله و زمان حمل این وسایل فرسوده شده و هزینه جا به جایی بسیار زیادی را نیازمند
                     بودند که همین اوامر باعث ایجاد صنعت اتومبیل سازی ایران گشت.. همزمان با افزایش
                     جمعیت شهر ها و رشد سریع تکنولوژی و پیاده سازی طرح های عمرانی و توسعه ای در کشور
                     باعث گردید مراودات بین شهری افزایش قابل توجه ای بیابد و باتوجه به و نبود زیر
                     ساخت لازم کشور در جهت رفع نیاز ارسال ، جمع آوری و توزیع مرسولات پیش از پیش نیاز
                     به ایجاد یک شبکه ای ارسال ، جمع آوری و توزیع مکانیزه و با بهره گیری از تکنولوژی
                     روز احساس میشد. شرکت کالاپست ( رویال بار سابق ) با بیش از چهل سال سابقه در حوزه
                     ای ارسال ، جمع آوری و توزیع مرسولات از طریق استفاده از شبکه ای حمل نقل بین شهری
                     ( اتوبوسی ) برآن شد که با سرمایه گذاری و بهره گیری از امکانات سخت افزاری و نرم
                     افزاری و به کار گیری گروهی از متخصصین داخلی و همکاری با شرکت ملی پست ایران نسبت
                     به طراحی اپلیکیشن ارسال ، جمع آوری و توزیع مرسولات با برند تجاری کالاپست اقدام
                     نموده است
                  </p>
                  <img src='/img/aboutUs.jpg' alt='about' className='info__about-image' />
               </div>
            </div>

            <div id='values' className='info__value'>
               <div className='info__value-content'>
                  <img src='/img/diamond.png' alt='diamond' className='info__value-img' />
                  <h2 className='info__value-title'>ارزش های بنیادی کالا پست</h2>
               </div>
               <ul className='kards'>
                  <li className='kards__card kards__card kards__card-aboutus'>
                     <img
                        className='info__value-image kards__card-image--aboutus'
                        src='/img/calling.jpg'
                     />
                     <h2 className='info__value-text'>پاسخگویی</h2>
                  </li>
                  <li className='kards__card kards__card kards__card-aboutus'>
                     <img
                        className='info__value-image kards__card-image--aboutus'
                        src='/img/fast.jpg'
                     />
                     <h2 className='info__value-text'>چابکی</h2>
                  </li>
                  <li className='kards__card kards__card kards__card-aboutus'>
                     <img
                        className='info__value-image kards__card-image--aboutus'
                        src='/img/innovation.jpg'
                     />
                     <h2 className='info__value-text'>نوآوری</h2>
                  </li>
               </ul>
            </div>

            <div id='rights' className='info__client'>
               <div className='info__client-content'>
                  <img src='/img/humanity.png' alt='aboutUs' className='info__client-img' />
                  <h2 className='info__client-title'>حقوق مشتریان</h2>
               </div>
               <ul className='info__client-list'>
                  <li className='info__client-item'>
                     مشتری حق دارد در محیطی دوستانه و سالم، در ارتباط با کالاپست باشد.
                  </li>
                  <li className='info__client-item'>
                     مشتری حق دارد تا پیش از ثبت سفارش، بتواند از زمان و هزینه ارسال بسته خود مطلع
                     شود.
                  </li>
                  <li className='info__client-item'>
                     مشتری حق دارد در هنگام ثبت سفارش، شیوه پرداخت هزینه خود را انتخاب کند.
                  </li>
                  <li className='info__client-item'>
                     گیرنده حق دارد از ارزش و هزینه ارسال بسته خود مطلع شود.
                  </li>
                  <li className='info__client-item'>
                     فرستنده حق دارد بتواند سفارش خود را لغو کند.
                  </li>
                  <li className='info__client-item'>
                     مشتری حق دارد بتواند شیوه دریافت خدمات را خود تعیین کند. (پیشفرض ارائه خدمات
                     درب به درب است)
                  </li>
                  <li className='info__client-item'>مشتری حق دارد از ممنوعات ارسال مطلع شود.</li>
                  <li className='info__client-item'>مشتری حق دارد کالاهای قاچاق را بشناسد.</li>
                  <li className='info__client-item'>
                     مشتری حق دارد مطابق با ارزش اظهاری بسته خود و منطبق با قوانین کالاپست، از خدمت
                     جبران خسارت بهره بگیرد.
                  </li>
                  <li className='info__client-item'>
                     مشتری حق دارد مطابق با قوانین کالاپست، درخواست استفاده از خدمت بسته بندی را
                     داشته باشد.
                  </li>
                  <li className='info__client-item'>
                     مشتری حق دارد در هر لحظه، از وضعیت بسته خود مطلع شود.
                  </li>
                  <li className='info__client-item'>
                     مشتری حق دارد در صورت عدم رضایت از خدمات دریافت شده، شکایت خود را از طریق درگاه
                     های کالاپست، ثبت و پیگیری کند.
                  </li>
               </ul>
            </div>

            <div id='managers' className='info__owner'>
               <div className='info__owner-content'>
                  <img src='/img/owner.png' alt='owner' className='info__owner-img' />
                  <h2 className='info__owner-title'>مدیران سازمانی</h2>
               </div>

               <ul className='kards'>
                  <li className='kards__card kards__card-aboutus info__owner-image'>
                     <img
                        className='kards__card-image--aboutus'
                        src='/img/ali-nabavi.png'
                        alt='owners'
                     />
                     <h2 className='info__owner-text'>رییس هیت مدیره آقای علی نبوی</h2>
                  </li>
                  <li className='kards__card kards__card-aboutus info__owner-image'>
                     <img
                        className='kards__card-image--aboutus'
                        src='/img/hossein-nabavi.png'
                        alt='owners'
                     />
                     <h2 className='info__owner-text'>مدیر عامل آقای حسین نبوی</h2>
                  </li>
                  <li className='kards__card kards__card-aboutus info__owner-image'>
                     <img
                        className='kards__card-image--aboutus'
                        src='/img/hasan-nabavi.png'
                        alt='owners'
                     />
                     <h2 className='info__owner-text'>مدیر امور مالی آقای حسن نبوی</h2>
                  </li>
                  <li className='kards__card kards__card-aboutus info__owner-image'>
                     <img
                        className='kards__card-image--aboutus'
                        src='/img/farrokhmanesh.JPG'
                        alt='owners'
                     />
                     <h2 className='info__owner-text'>مدیر برند و تبلیغات آقای اشکان فرخ منش</h2>
                  </li>
                  <li className='kards__card kards__card-aboutus info__owner-image'>
                     <img
                        className='kards__card-image--aboutus'
                        src='/img/choopani.png'
                        alt='owners'
                     />
                     <h2 className='info__owner-text'>مدیر امور اداری آقای مسعود چوپانی</h2>
                  </li>
               </ul>
            </div>

            <div id='contact' className='box info__call'>
               <div className='info__call-content'>
                  <div className='info__call-phone'>
                     <div className='info__call-phone-content'>
                        <img src='/img/phone.svg' alt='phone' className='info__call-phone-img' />
                        <h2 className='info__call-phone-title'>تماس با ما</h2>
                     </div>
                     <p
                        className='info__call-address-text'
                        style={{ textAlign: 'center', paddingTop: '10px' }}
                     >
                        03134358310-14
                     </p>
                  </div>
                  <div className='info__call-email' style={{ margin: 0 }}>
                     <div className='info__call-email-content'>
                        <img src='/img/email.svg' alt='phone' className='info__call-email-img' />
                        <h2 className='info__call-email-title'>ایمیل</h2>
                     </div>
                     <p
                        className='info__call-address-text'
                        style={{ textAlign: 'center', paddingTop: '10px' }}
                     >
                        kalapost.co@gmail.com
                     </p>
                     {/* <ul className='info__call-email-list'>
                        <li className='info__call-email-item'>kalapost.co@gmail.com</li>
                     </ul> */}
                  </div>
                  <div className='info__call-address'>
                     <div className='info__call-address-content'>
                        <img
                           src='/img/location.svg'
                           alt='location'
                           className='info__call-address-img'
                        />
                        <h1 className='info__call-address-title'>آدرس</h1>
                     </div>
                     <p className='info__call-address-text' style={{ paddingTop: '10px' }}>
                        اصفهان، اتوبان کاوه، خیابان جابر انصاری، خیابان ابونعیم جنوبی، میدان
                        میرعماد، اتوماسیون مرکزی کالاپست
                     </p>
                  </div>
               </div>
               <div className='info__call-map'>
                  <MapContainer
                     center={[32.70065135074517, 51.67066269327279]}
                     zoom={13}
                     scrollWheelZoom={false}
                     style={{ width: '100%', height: 250, flex: '0 0 auto' }}
                  >
                     <TileLayer
                        attribution='&copy; <a href="://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                     />
                     <Marker
                        position={[32.70065135074517, 51.67066269327279]}
                        icon={skater}
                        onclick={(event) => event.target.closePopup()}
                     ></Marker>
                  </MapContainer>
                  {/* <div id="map"></div> */}
               </div>
            </div>
         </section>
         <Link to='/order' className='main__Send-package'>
            <img className='main__Send-package-img' src='/img/postfix.png' />
            <h4>ارسال بسته</h4>
         </Link>
      </main>
   );
};

export default AboutUs;
